// src/layouts/products/components/ProductDetailsView/PriceAdjustersTab.js
import React, { useState } from 'react';

// --- Material-UI Core Components ---
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Collapse,
  IconButton,
  Icon,
  Paper,
  Divider,
  Card,
} from '@mui/material';
import { grey } from '@mui/material/colors';

import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';

// --- START: FAKE DATA FOR DEMONSTRATION ---
const fakeCpqData = {
  discountSchedules: [
    {
      sfid: 'a0Fd2000003vh1hEAA',
      productReference: 'Charger',
      productOptionIdentifier: null,
      productIdentifier: ['Iphone 15'],
      pricebookReference: null,
      originalDSReference: null,
      name: 'Discount One',
      id: 'a0Fd2000003vh1hEAA',
      fields: {
        SBQQ__UserDefined__c: 'false',
        SBQQ__UsePriceForAmount__c: 'false',
        SBQQ__Type__c: 'Range',
        SBQQ__QuoteLineQuantityField__c: 'Quantity',
        SBQQ__QuoteLine__c: null,
        SBQQ__Quote__c: null,
        SBQQ__Product__c: '01td2000005zYOTAA2',
        SBQQ__PriceScale__c: '2',
        SBQQ__Pricebook__c: null,
        SBQQ__OverrideBehavior__c: null,
        SBQQ__OriginalDiscountSchedule__c: null,
        SBQQ__OrderProduct__c: null,
        SBQQ__Order__c: null,
        SBQQ__IncludeBundledProducts__c: 'false',
        SBQQ__ExcludedPricebookIds__c: null,
        SBQQ__DiscountUnit__c: 'Percent',
        SBQQ__Description__c: null,
        SBQQ__CrossProducts__c: 'false',
        SBQQ__CrossOrders__c: 'false',
        SBQQ__ConstraintField__c: null,
        SBQQ__AggregationScope__c: null,
        SBQQ__Account__c: null,
      },
      featureIdentifier: null,
      discountTiers: [
        {
          sfId: 'a0Gd200000479vVEAQ',
          name: 'Tier 1',
          id: 'a0Gd200000479vVEAQ',
          fields: {
            SBQQ__UpperBound__c: '10',
            SBQQ__Schedule__c: 'a0Fd2000003vh1hEAA',
            SBQQ__Price__c: null,
            SBQQ__Number__c: '1',
            SBQQ__LowerBound__c: '0',
            SBQQ__DiscountAmount__c: null,
            SBQQ__Discount__c: '10.0000000000',
          },
        },
      ],
    },
    {
      sfid: 'a0Fd2000004JG1xEAG',
      productReference: 'Case',
      productOptionIdentifier: null,
      productIdentifier: ['CPU 2.8GHz i7'],
      pricebookReference: 'Standard Price Book',
      originalDSReference: null,
      name: 'Discount Three ',
      id: 'a0Fd2000004JG1xEAG',
      fields: {
        SBQQ__UserDefined__c: 'false',
        SBQQ__UsePriceForAmount__c: 'false',
        SBQQ__Type__c: 'Slab',
        SBQQ__QuoteLineQuantityField__c: 'Quantity',
        SBQQ__QuoteLine__c: null,
        SBQQ__Quote__c: null,
        SBQQ__Product__c: '01td2000005zYQ5AAM',
        SBQQ__PriceScale__c: '2',
        SBQQ__Pricebook__c: '01sd2000003eSDZAA2',
        SBQQ__OverrideBehavior__c: null,
        SBQQ__OriginalDiscountSchedule__c: null,
        SBQQ__OrderProduct__c: null,
        SBQQ__Order__c: null,
        SBQQ__IncludeBundledProducts__c: 'true',
        SBQQ__ExcludedPricebookIds__c: null,
        SBQQ__DiscountUnit__c: 'Amount',
        SBQQ__Description__c: null,
        SBQQ__CrossProducts__c: 'true',
        SBQQ__CrossOrders__c: 'false',
        SBQQ__ConstraintField__c: 'Account__c',
        SBQQ__AggregationScope__c: null,
        SBQQ__Account__c: null,
      },
      featureIdentifier: null,
      discountTiers: [
        {
          sfId: 'a0Gd2000004diJpEAI',
          name: 'Tier 1',
          id: 'a0Gd2000004diJpEAI',
          fields: {
            SBQQ__UpperBound__c: '5',
            SBQQ__Schedule__c: 'a0Fd2000004JG1xEAG',
            SBQQ__Price__c: null,
            SBQQ__Number__c: '1',
            SBQQ__LowerBound__c: '1',
            SBQQ__DiscountAmount__c: '1.00',
            SBQQ__Discount__c: null,
          },
        },
        {
          sfId: 'a0Gd2000004diZxEAI',
          name: 'Tier 4',
          id: 'a0Gd2000004diZxEAI',
          fields: {
            SBQQ__UpperBound__c: '50',
            SBQQ__Schedule__c: 'a0Fd2000004JG1xEAG',
            SBQQ__Price__c: null,
            SBQQ__Number__c: '2',
            SBQQ__LowerBound__c: '5',
            SBQQ__DiscountAmount__c: '5.00',
            SBQQ__Discount__c: null,
          },
        },
      ],
    },
  ],
};

const fakeRcaData = {
  priceAdjustmentTiers: [
    {
      recordId: '84YHr000000ANidMAG',
      fields: { TierValue: 10.0, TierType: 'AdjustmentAmount', LowerBound: 0 },
      productSellingModelName: null,
      productName: 'Laptop',
      priceAdjustmentScheduleName: 'Standard Price Adjustment Tier',
    },
    {
      recordId: '84YHr000000ANiiMAG',
      fields: { TierValue: 20.0, TierType: 'AdjustmentAmount', LowerBound: 11 },
      productSellingModelName: null,
      productName: 'Laptop',
      priceAdjustmentScheduleName: 'Standard Price Adjustment Tier',
    },
    {
      recordId: '84YHr000000BrmHMAS',
      fields: { TierValue: 10.0, TierType: 'AdjustmentAmount', LowerBound: 3 },
      productSellingModelName: null,
      productName: 'Laptop',
      priceAdjustmentScheduleName: 'My New Schedule',
    },
  ],
  priceAdjustmentSchedules: [
    {
      recordId: '84XHr000000AMGLMA4',
      fields: { ScheduleType: 'Volume', AdjustmentMethod: 'Range' },
      name: 'Standard Price Adjustment Tier',
    },
    {
      recordId: '84XHr000000Bw0mMAC',
      fields: { ScheduleType: 'Volume', AdjustmentMethod: 'Range' },
      name: 'My New Schedule',
    },
  ],
};
// --- END: FAKE DATA FOR DEMONSTRATION ---

const DiscountTiersTable = ({ tiers }) => {
  if (!tiers || tiers.length === 0) return null;
  return (
    <ArgonBox mt={2}>
      <ArgonTypography variant="subtitle1" fontWeight="medium" mb={1}>
        Discount Tiers
      </ArgonTypography>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead sx={{ backgroundColor: grey[200], display: 'contents' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>
                <ArgonTypography variant="caption" fontWeight="bold">
                  Tier Name
                </ArgonTypography>
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>
                <ArgonTypography variant="caption" fontWeight="bold">
                  Lower Bound
                </ArgonTypography>
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>
                <ArgonTypography variant="caption" fontWeight="bold">
                  Upper Bound
                </ArgonTypography>
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>
                <ArgonTypography variant="caption" fontWeight="bold">
                  Discount
                </ArgonTypography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tiers.map((tier) => {
              const fields = tier.fields || {};
              const discountValue =
                fields.SBQQ__Discount__c != null
                  ? `${parseFloat(fields.SBQQ__Discount__c).toFixed(2)}%`
                  : fields.SBQQ__DiscountAmount__c != null
                  ? `$${parseFloat(fields.SBQQ__DiscountAmount__c).toFixed(2)}`
                  : 'N/A';
              return (
                <TableRow key={tier.id}>
                  <TableCell>{tier.name}</TableCell>
                  <TableCell>{fields.SBQQ__LowerBound__c}</TableCell>
                  <TableCell>{fields.SBQQ__UpperBound__c || 'And up'}</TableCell>
                  <TableCell>{discountValue}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </ArgonBox>
  );
};

const CpqView = ({ schedules, basicFields, renderFieldsProp }) => {
  const [expandedItem, setExpandedItem] = useState({});
  const handleItemClick = (itemId) => setExpandedItem((prev) => ({ ...prev, [itemId]: !prev[itemId] }));

  if (!schedules || schedules.length === 0) {
    return <ArgonTypography variant="body2">No CPQ Discount Schedules available.</ArgonTypography>;
  }

  return schedules.map((schedule) => {
    const filteredFields = Object.keys(schedule.fields || {})
      .filter((key) => basicFields.includes(key))
      .reduce((obj, key) => ({ ...obj, [key]: schedule.fields[key] }), {});

    return (
      <Card sx={{ marginBottom: '1rem' }} key={schedule.id}>
        <ArgonBox mb={0.5} mt={0.5}>
          <ArgonBox
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            onClick={() => handleItemClick(schedule.id)}
            style={{ cursor: 'pointer' }}
            borderRadius="md"
            p={1}
          >
            <ArgonTypography variant="h6" fontWeight="medium" color="secondary" ml={1}>
              {schedule.name}
            </ArgonTypography>
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                handleItemClick(schedule.id);
              }}
            >
              <Icon>{expandedItem[schedule.id] ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</Icon>
            </IconButton>
          </ArgonBox>
          <Collapse in={expandedItem[schedule.id]} timeout="auto" unmountOnExit>
            <ArgonBox p={2} sx={{ borderRadius: 'md' }}>
              {renderFieldsProp(filteredFields)}
              <DiscountTiersTable tiers={schedule.discountTiers} />
            </ArgonBox>
          </Collapse>
        </ArgonBox>
      </Card>
    );
  });
};

const RcaTiersTable = ({ tiers, scheduleName }) => {
  const relevantTiers = tiers?.filter((tier) => tier.priceAdjustmentScheduleName === scheduleName) || [];
  if (relevantTiers.length === 0) return null;
  return (
    <ArgonBox mt={2}>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead sx={{ backgroundColor: grey[200], display: 'contents' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>
                <ArgonTypography variant="caption" fontWeight="bold">
                  Lower Bound
                </ArgonTypography>
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>
                <ArgonTypography variant="caption" fontWeight="bold">
                  Tier Type
                </ArgonTypography>
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>
                <ArgonTypography variant="caption" fontWeight="bold">
                  Value
                </ArgonTypography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {relevantTiers.map((tier) => (
              <TableRow key={tier.recordId}>
                <TableCell>{tier.fields.LowerBound}</TableCell>
                <TableCell>{tier.fields.TierType}</TableCell>
                <TableCell>{tier.fields.TierValue}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </ArgonBox>
  );
};

const RcaView = ({ schedules, tiers, basicFields, renderFieldsProp }) => {
  const [expandedItem, setExpandedItem] = useState({});
  const handleItemClick = (itemId) => setExpandedItem((prev) => ({ ...prev, [itemId]: !prev[itemId] }));

  if (!schedules || schedules.length === 0) {
    return <ArgonTypography variant="body2">No RCA Price Adjustment Schedules available.</ArgonTypography>;
  }

  return schedules.map((schedule) => {
    const filteredFields = Object.keys(schedule.fields || {})
      .filter((key) => basicFields.includes(key))
      .reduce((obj, key) => ({ ...obj, [key]: schedule.fields[key] }), {});

    return (
      <Card sx={{ marginBottom: '1rem' }} key={schedule.recordId}>
        <ArgonBox mb={0.5} mt={0.5}>
          <ArgonBox
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            onClick={() => handleItemClick(schedule.recordId)}
            style={{ cursor: 'pointer' }}
            p={1}
            borderRadius="md"
          >
            <ArgonTypography variant="h6" fontWeight="medium" color="secondary" ml={1}>
              {schedule.name}
            </ArgonTypography>
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                handleItemClick(schedule.recordId);
              }}
            >
              <Icon>{expandedItem[schedule.recordId] ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</Icon>
            </IconButton>
          </ArgonBox>
          <Collapse in={expandedItem[schedule.recordId]} timeout="auto" unmountOnExit>
            <ArgonBox p={2} sx={{ borderRadius: 'md' }}>
              {renderFieldsProp(filteredFields)}
              <RcaTiersTable tiers={tiers} scheduleName={schedule.name.replace(' (Sample)', '')} />
            </ArgonBox>
          </Collapse>
        </ArgonBox>
      </Card>
    );
  });
};

function PriceAdjustersTab({ product, org, renderFieldsProp, cpqBasicFields = [], rcaBasicFields = [] }) {
  const orgType = org?.type; // Make it case-insensitive

  const renderContent = () => {
    switch (orgType) {
      case 'CPQ':
        return (
          <CpqView
            // --- MODIFIED: Use fake data as a fallback ---
            schedules={product.related_data?.discountSchedules || fakeCpqData.discountSchedules}
            basicFields={cpqBasicFields}
            renderFieldsProp={renderFieldsProp}
          />
        );
      case 'RC':
        return (
          <RcaView
            // --- MODIFIED: Use fake data as a fallback ---
            schedules={product.related_data?.priceAdjustmentSchedules || fakeRcaData.priceAdjustmentSchedules}
            tiers={product.related_data?.priceAdjustmentTiers || fakeRcaData.priceAdjustmentTiers}
            basicFields={rcaBasicFields}
            renderFieldsProp={renderFieldsProp}
          />
        );
      default:
        return (
          <ArgonTypography variant="body2">
            No Price Adjusters available for this product or organization type.
          </ArgonTypography>
        );
    }
  };

  return <ArgonBox p={3}>{renderContent()}</ArgonBox>;
}

export default PriceAdjustersTab;
